<template>
  <div class="row">
    <div class="col-lg-12 col-md-12 col-sm-12">
      <c-card title="기본정보" class="cardClassDetailForm">
        <template slot="card-detail">
          <div class="col-xs-6 col-sm-6 col-md-3 col-lg-3 col-xl-3">
            <c-plant 
              :disabled="true"
              :editable="editable" 
              type="edit" 
              name="plantCd" 
              v-model="eduInfo.plantCd" />
          </div>
          <div class="col-xs-4 col-sm-4 col-md-3 col-lg-3 col-xl-3">
            <c-datepicker
              :editable="editable"
              :disabled="true"
              label="교육년도"
              type="year"
              name="educationYear"
              v-model="eduInfo.educationYear">
            </c-datepicker>
          </div>
        </template>
      </c-card>
    </div>
    <div class="col-xs-12 col-sm-12 col-md-12 col-lg-12 col-xl-12">
      <c-table
        ref="table"
        title="연간교육계획 목록"
        :columns="grid.columns"
        :gridHeight="grid.height"
        :data="grid.data"
        :filtering="false"
        :columnSetting="false"
        :usePaging="false"
        :hideBottom="true"
        :isExcelDown="false"
        cardClass="topcolor-orange"
      >
      </c-table>
    </div>
  </div>
</template>

<script>
import selectConfig from '@/js/selectConfig';
export default {
  name: 'annualEducationPlanDetail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        eduEducationId: '',
        disabled: false,
        educationYear: '',
        eduCourseId: '',
        educationMonth: '',
        plantCd: '',
        stepFlag: '',
        approvalStatusCd: '',
        educationKindCdLarge: null,
      }),
    },
  },
  data() {
    return {
      eduInfo: {
        plantCd: null,
        educationYear: '',
      },
      grid: {
        columns: [
          {
            name: 'educationCourseName',
            field: 'educationCourseName',
            label: '교육과정',
            align: 'center',
            style: 'width:250px', 
            sortable: false,
          },
          {
            name: 'educationName',
            field: 'educationName',
            label: '교육명',
            align: 'left',
            style: 'width:200px', 
            sortable: false,
          },
          {
            name: 'mainTargetAudience',
            field: 'mainTargetAudience',
            label: '주요 대상자',
            style: 'width:150px',
            align: 'left',
            sortable: false,
          },
          {
            name: 'educationDate',
            field: 'educationDate',
            label: '교육일',
            style: 'width:120px',
            align: 'center',
            sortable: false,
          },
          {
            name: 'educationMethodName',
            field: 'educationMethodName',
            label: '교육방법',
            align: 'center',
            style: 'width:100px',
            sortable: false,
          },
          {
            name: 'educationLocation',
            field: 'educationLocation',
            label: '교육장소',
            style: 'width:120px',
            align: 'left',
            sortable: false,
          },
        ],
        data: [],
        height: '500px'
      },
      editable: true,
      detailUrl: '',
    };
  },
  watch: {
  },
  computed: {
    resultFlag() {
      /**
       * 결과로 들어온 경우 해당 팝업에서 쓰기권한 해제
       */
      return this.popupParam.stepFlag === 'Y'
    },
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
    this.init();
  },
  mounted() {
  },
  beforeDestroy() {
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      // url setting
      this.detailUrl = selectConfig.sop.edu.annual.get.url;
      // list setting
      if (this.popupParam.eduCourseId) {
        this.eduInfo.plantCd = this.popupParam.plantCd
        this.eduInfo.educationYear = this.popupParam.educationYear
      }
      this.getList();
    },
    getList() {
      if (this.eduInfo.plantCd && this.eduInfo.educationYear) {
        this.$http.url = this.$format(this.detailUrl, this.eduInfo.educationYear);
        this.$http.type = 'GET';
        this.$http.param = {
          plantCd: this.eduInfo.plantCd,
          eduCourseId: this.popupParam.eduCourseId,
          educationMonth: this.popupParam.educationMonth,
          stepFlag: this.popupParam.stepFlag,
          educationKindCdLarge: this.popupParam.educationKindCdLarge,
        };
        this.$http.request((_result) => {
          this.grid.data = _result.data;
          this.$_.forEach(this.grid.data, _item => {
            _item.educationDate = (_item.educationStartDate === _item.educationEndDate ? 
              _item.educationStartDate : (_item.educationStartDate + ' ~ ' + _item.educationEndDate))
          })
        },);
      } else {
        this.grid.data = [];
      }
    },
  }
};
</script>